/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "value"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the content value of the input."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "align"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the text alignment of the input. Can be ", _jsx(_components.code, {
              children: "left"
            }), ", ", _jsx(_components.code, {
              children: "right"
            }), " or ", _jsx(_components.code, {
              children: "center"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "left"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " prepends the Form Label component. If no ID is provided, a random ID is created."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label_direction"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "label_direction=\"vertical\""
            }), " to change the label layout direction. Defaults to ", _jsx(_components.code, {
              children: "horizontal"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label_sr_only"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "true"
            }), " to make the label only readable by screen readers."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " text with a status message. The style defaults to an error message. You can use ", _jsx(_components.code, {
              children: "true"
            }), " to only get the status color, without a message."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the state of the status. Currently, there are two statuses ", _jsx(_components.code, {
              children: "[error, info]"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "error"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_props"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use an object to define additional FormStatus properties."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "globalStatus"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the ", _jsx(_components.a, {
              href: "/uilib/components/global-status/properties/#configuration-object",
              children: "configuration"
            }), " used for the target ", _jsx(_components.a, {
              href: "/uilib/components/global-status",
              children: "GlobalStatus"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "placeholder"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the placeholder which shows up once the input value is empty"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " icon to show before or after the input / placeholder. Can be either a string defining a primary icon or a Component using an SVG icon of either 16px or 24px."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the position of icon inside the input. Set to ", _jsx(_components.code, {
              children: "left"
            }), " or ", _jsx(_components.code, {
              children: "right"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "left"
            }), " if not set."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the icon size of the icon shows. Defaults to ", _jsx(_components.code, {
              children: "medium"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "keep_placeholder"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " in case the ", _jsx(_components.code, {
              children: "placeholder"
            }), " has to be kept during focus. By default, the placeholder disappears on focus."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "input_class"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " in case we have to set a custom input class."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "type"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " choose between ", _jsx(_components.code, {
              children: "text"
            }), ", ", _jsx(_components.code, {
              children: "number"
            }), ", ", _jsx(_components.code, {
              children: "email"
            }), ", ", _jsx(_components.code, {
              children: "password"
            }), ", ", _jsx(_components.code, {
              children: "url"
            }), ", ", _jsx(_components.code, {
              children: "tel"
            }), " and ", _jsx(_components.code, {
              children: "search"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "autocomplete"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defaults to ", _jsx(_components.code, {
              children: "off"
            }), ". Set to ", _jsx(_components.code, {
              children: "on"
            }), " or any of ", _jsxs(_components.a, {
              href: "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete",
              children: ["allowed ", _jsx(_components.code, {
                children: "attributes"
              })]
            }), ". Keep in mind, 1. you may have to define a ", _jsx(_components.code, {
              children: "name"
            }), ", 2. have the input as a descendant of a ", _jsx(_components.code, {
              children: "<form>"
            }), " element, 3. and have a submit button inside the form."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "submit_button_title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " title attribute for the search icon. Only relevant if search input."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "suffix"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " text describing the content of the input more than the label. you can also send in a React component, so it gets wrapped inside the Input component."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the sizes you can choose is ", _jsx(_components.code, {
              children: "small"
            }), " (1.5rem), ", _jsx(_components.code, {
              children: "default"
            }), " (2rem), ", _jsx(_components.code, {
              children: "medium"
            }), " (2.5rem) and ", _jsx(_components.code, {
              children: "large"
            }), " (3rem) are supported component sizes. Defaults to ", _jsx(_components.code, {
              children: "default"
            }), " / ", _jsx(_components.code, {
              children: "null"
            }), ". Also, if you define a number like ", _jsx(_components.code, {
              children: "size=\"2\""
            }), " then it will be forwarded as the input element attribute."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "selectall"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", then the whole input value gets selected on the entry focus. A second click will place the cursor on the wanted position."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "clear"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", then a clear button will be shown which lets the user clear any given input value."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "stretch"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", then the input field will be 100% in ", _jsx(_components.code, {
              children: "width"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", an overlaying skeleton with animation will be shown."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "input_attributes"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " provide the Input element with any attributes by using an Object ", _jsx(_components.code, {
              children: "input_attributes={{size:'2'}}"
            }), " or a JSON Object ", _jsx(_components.code, {
              children: "input_attributes='{\"size\":\"2\"}'"
            }), ". ", _jsx(_components.strong, {
              children: "NB:"
            }), " Keep in mind, that also every not listed component property will be sent along and set as an Input element attribute."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "input_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines a custom visual state of the input. Use it only if you have to simulate a custom state. Currently are three statuses ", _jsx(_components.code, {
              children: "virgin"
            }), " , ", _jsx(_components.code, {
              children: "focus"
            }), " and ", _jsx(_components.code, {
              children: "dirty"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "null"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "submit_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " accepts a React element which will show up like the \"submit button\" would do on ", _jsx(_components.code, {
              children: "type=\"search\""
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inner_ref"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " by providing a React.ref we can get the internally used input element (DOM). E.g. ", _jsx(_components.code, {
              children: "inner_ref={myRef}"
            }), " by using ", _jsx(_components.code, {
              children: "React.createRef()"
            }), " or ", _jsx(_components.code, {
              children: "React.useRef()"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "input_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(internal)"
            }), " by providing a new component we can change the internally used element. Also supports a string only, like ", _jsx(_components.code, {
              children: "input_element=\"input\""
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inner_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(internal)"
            }), " by providing a new component to be rendered inside the \"shell\" – we can add a freely customizable internal element. Used by the Autocomplete component."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/components/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
